// Fetch every authorized page so filters and plan assignment never hide later athletes.
export async function fetchCoachAthletes(client, api, orgId, teamId, signal) {
  const athletes = new Map();
  let offset = 0;
  do {
    const { data } = await client.get(`${api}/coach/${orgId}/athletes`, {
      params: { offset, limit: 100, ...(teamId ? { team_id: teamId } : {}) },
      signal,
    });
    for (const athlete of data.athletes || []) athletes.set(athlete.user_id, athlete);
    const next = data.next_offset;
    if (next == null) break;
    if (next <= offset) throw new Error('Invalid athlete pagination response');
    offset = next;
  } while (true);
  return [...athletes.values()].sort((a, b) => (a.username || '').localeCompare(b.username || ''));
}
